import { useState } from "react"
import { useNavigate } from "react-router-dom"

import { useAuthorizedAxiosClient } from "../../../common/axios"
import SelectEmailCampaignDialog from "../components/SelectEmailCampaignDialog"

export default function SendEmailCampaignDialog({ candidate, open, onClose }) {
  const [isSending, setIsSending] = useState(false)
  const axios = useAuthorizedAxiosClient()
  const navigate = useNavigate()

  function handleDialogClosed() {
    onClose()
  }

  function handleSendButtonClicked(selectedCampaign, emailBody) {
    setIsSending(true)
    axios
      .post(
        `/workflows/api/email/send-campaign/${selectedCampaign.id}/candidate/${candidate.id}/`,
        { email_body: emailBody }
      )
      .then(({ data }) => {
        onClose(data)
      })
      .finally(() => setIsSending(false))
  }

  return (
    <SelectEmailCampaignDialog
      open={open}
      onClose={handleDialogClosed}
      bodyPropName="rendered_body"
      editable
      onCreateLinkClicked={() => navigate("/campaigns/email/create")}
      primaryButton={{
        text: "Send",
        isLoading: isSending,
        onClick: handleSendButtonClicked,
      }}
      campaignsAPIURL={`/workflows/api/email/select-campaign/${candidate.id}/`}
    />
  )
}
